<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>{{ $t('register.verification.accountVerification') }}</h1>
      </v-col>
    </v-row>
    <v-row  v-if="$apollo.queries.user.loading" >
      <v-col>
        <v-skeleton-loader class="mx-auto" type="heading, heading,  paragraph, button" max-width="400px" />
      </v-col> 
    </v-row>
    <v-row v-else-if="!needsVerification" align="center" class="pa-15">
      <v-col>
        <v-row>
          <v-col>
            <v-avatar size="65" color="green">
              <v-icon color="white" size="80">mdi-check-circle</v-icon>
            </v-avatar>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            ><h2>{{ $t("register.verification.accountIsVerified") }}</h2>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-else-if="needsVerification">
    <v-row>
      <v-col>{{ $t('register.verification.pleaseVerifyYourEmail') }}</v-col>
    </v-row>
    <v-row>
      <v-col>
        <ApolloMutation :mutation="VERIFY_EMAIL" @done="() => { emailSent = true }">
          <template v-slot="{ mutate, loading, error }">
            <v-btn v-if="!emailSent"
              :loading="loading"
              :disabled="loading"
              @click="mutate"
              color="secondary"
              class="px-15 white--text"
              elevation="0"
              >{{ 'Send Verification Email' }}</v-btn
            >
            <div v-else>
              <v-alert class="mx-auto" style="max-width: 300px" type="info">{{ $t('register.verification.verificationEmailSent') }}</v-alert>
              <p>{{ $t('register.verification.ifYouDontReceive') }}</p>
            </div>
            {{ error }}
          </template>
        </ApolloMutation>
      </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import hasLoggedInUser from '@/mixins/hasLoggedInUser'
import { VERIFY_EMAIL } from '@/graphql/UserQueries'
export default {
  mixins: [hasLoggedInUser],
  data() {
    return {
      emailSent: false,
    }
  },
  computed: {
    needsVerification() {
      return this.user && this.user.isVerified == false
    },
    VERIFY_EMAIL() {
      return VERIFY_EMAIL
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-skeleton-loader__bone {
  margin: 10px 0;
}
</style>